export const testimonials = [
  {
    id: 1,
    text: "Working with Konecta on our year-end RSVP system made a significant difference. Their platform streamlined the entire process—from invitations and RSVP management to on-the-day scanning and check-ins. What stood out most was their responsiveness and hands-on support whenever issues arose. They ensured everything ran smoothly from start to finish.",
    name: 'Nonhlanhla Mcina',
    role: 'Adapt IT',
  },
  {
    id: 2,
    text: "Konecta has been an outstanding partner through our Enterprise and Supplier Development programme. Their commitment to collaboration and quality delivery has strengthened our initiatives and supported the growth of our partners. We value the relationship and look forward to continuing this impactful partnership.",
    name: 'Sandra Machemba',
    role: 'Adapt IT',
  },
  {
    id: 3,
    text: "It was a privilege to work with Konecta during Mission Week in Thembisa, in partnership with the World Bank. The engagement created a strong platform for collaboration between government and private sector stakeholders, focusing on digital economy opportunities, skills development, and enterprise support. Konecta demonstrated a clear commitment to inclusive growth and township economic development through digital innovation.",
    name: 'Devanand Loykisoonlal',
    role: 'City of Ekurhuleni',
  },
  {
    id: 4,
    text: "Konecta supported the development of the Thembisa Digital Strategy with professionalism, expertise, and strong stakeholder collaboration. Their strategic input contributed to a practical and impactful digital roadmap aligned with socio-economic development goals. We recommend Konecta for digital strategy development and advisory services.",
    name: 'Lethu Collen Masango',
    role: 'World Bank',
  },
  {
    id: 5,
    text: "The Internet Society South Africa Gauteng Chapter recognises Konecta for their valuable contribution to community initiatives. They developed a training and content management system and provided Wi-Fi advertising solutions through their community network. We highly recommend Konecta for system development, Wi-Fi solutions, and training services.",
    name: 'Thato Mfikwe',
    role: 'ISOC SA Gauteng Chapter',
  },
  {
    id: 6,
    text: "Konecta developed the Gauteng On The Move (GOTM) intermodal route planner app and supported its digital and social media rollout. The application demonstrated strong innovation and performed well in the market. We highly recommend Konecta for app and web development, as well as digital marketing campaigns.",
    name: 'T Kgobe',
    role: 'Gauteng On The Move (GPDRT)',
  },
  {
    id: 7,
    text: "The AI presentation was very informative and stimulating. It sparked further interest and encouraged deeper engagement and exploration of the topic. A highly valuable and thought-provoking session.",
    name: 'Luke Kataika',
    role: 'Ecobank Malawi',
  },
  {
    id: 8,
    text: "The summit was exceptionally well organised, with highly informative and insightful sessions throughout. The presentations delivered real value, with practical solutions that resonated across industries. It was a powerful platform for learning, collaboration, and connection, truly impactful and inspiring. I look forward to seeing more initiatives like this in the future.",
    name: 'Anonymous Attendee',
    role: 'WiTechnology Summit 2025',
  },
];
